<template>
    <div id="page-header">
        <div class="container-fluid">
            <div class="page-header-wrapper">
                <div class="page-header-content">
                    <h1>404 Error</h1>

                    <p>Unfortunately this page does not exist, please return to the home page</p>

                    <p><RouterLink to="/" class="button">Back to the homepage</RouterLink></p>
                </div>
                <div class="page-header-image">
                    <img :src=image alt="photo">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            image: require('@/assets/404.jpg'),
        }
    },
}

</script>

<style>
@import '@/css/errorSection.css';
</style>